module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "350px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword#For"
    }
  }, [_vm._v("Foreword & Acknowledgments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction#Int"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#C1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#C1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Long Beach, Land of the Tongva and "), _c('i', [_vm._v("Joyas")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Vagrants and Female Impersonators")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hey Sailor, Are You New in Town?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Here Come the Lesbians")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Briggs Brought Us Out")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Love a Parade")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("People Are Dying. Does Anyone Care?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LGBTQA Politics")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter09#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter09#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So Many Rainbow Heroes")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creating a LGBTQA Cultural Center")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/LGBTQ_resources#res",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LGBTQ Resources")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb868e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0